<template>
  <div>
    <v-layout
      column
      justify-center
      align-center
      class="mb-4 grey--text text--darken-3"
      style="word-break: break-word"
    >
      <v-layout align-center>
        <v-icon
          color="info"
          class="mr-3"
          medium
        >
          info_outline
        </v-icon>
        <div>
          {{
            alreadyRequested
              ? $t('feedbackSubmitted')
              : $t('userManagementRequestFeatureHint')
          }}
        </div>
      </v-layout>
      <v-btn
        v-if="!alreadyRequested"
        outline
        round
        color="info"
        class="mt-3"
        :loading="busy"
        @click="requestUsermanagementFeature()"
      >
        {{
          $vuetify.breakpoint.xs
            ? $t('userManagementRequestFeatureButtonShort')
            : $t('userManagementRequestFeatureButton')
        }}
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
export default {
  data() {
    return {
      busy: false,
      alreadyRequested: false,
    };
  },
  methods: {
    /**
     * Tell support that User wants to use the usermanagement feature.
     */
    requestUsermanagementFeature() {
      this.busy = true;
      this.$api
        .requestUsermanagementFeature()
        .then((response) => {
          this.$bus.$emit('alert-success', {
            message: 'feedbackSubmitted',
            translate: true,
            timeout: 12000,
          });
        })
        .finally(() => {
          this.busy = false;
          this.alreadyRequested = true;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/UserManagement/RequestFeatureHint.vue